import React from 'react';
import ViolationDetailSection from '../../../sections/AdminDashboard/Moderation/ViolationDetail';

const AdminViolationDetail = () => {
  return <ViolationDetailSection />;
};

export default AdminViolationDetail;

